import { render, staticRenderFns } from "./eduTrainManage.vue?vue&type=template&id=067a7c21&scoped=true&"
import script from "./eduTrainManage.vue?vue&type=script&lang=js&"
export * from "./eduTrainManage.vue?vue&type=script&lang=js&"
import style0 from "./eduTrainManage.vue?vue&type=style&index=0&id=067a7c21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067a7c21",
  null
  
)

export default component.exports